
function regex(string, key, params) {
    var re = new RegExp(params.pattern);
    if (!re.test(string))
        return {key: key};
    return {};
}

function email(string, key, params) {
    return regex(string, key, {
        pattern: '^(([^<>()\\[\\]\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
    })
}

function length(string, key, params) {
    var min = 'min' in params ? params.min : -Infinity;
    var max = 'max' in params ? params.max : Infinity;
    if (string === null || string === undefined)
        string = '';
    if (params.enableEmptyAnyway && string === '')
        return {};
    if (string.length >= min && string.length <= max)
        return {};
    var res = {key: key};
    if (min !== -Infinity)
        res.min = min;
    if (max !== Infinity)
        res.max = max;
    return res;
}

function required(string, key, params) {
    return (string === null || string === undefined || string.length == 0) ? {key: key} : {};
}

function equalTo(string, key, params, data) {
    if (string !== data[params.fieldName])
        return {key: key};
    return {};
}

module.exports = {regex: regex, email: email, length: length, equalTo: equalTo, required: required};
